import { useEffect, useState } from "react";
import MemberLayout from "../components/MemberLayout";
import { api, formatRupiah, formatDate } from "../lib/api";
import { HandCoins } from "lucide-react";

export default function MemberPinjaman() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/member/pinjaman").then((r) => setRows(r.data)); }, []);

  return (
    <MemberLayout>
      <div className="space-y-5">
        <h1 className="font-heading font-extrabold text-3xl tracking-tight text-brand-ink">Pinjaman Saya</h1>

        {rows.length === 0 ? (
          <div className="bg-white rounded-3xl border border-dashed border-brand/15 p-10 text-center text-brand-muted">Belum ada pinjaman.</div>
        ) : (
          <ul className="space-y-3" data-testid="member-pinjaman-list">
            {rows.map((p) => (
              <li key={p.id} className="bg-white rounded-3xl border border-brand/10 shadow-sm p-5">
                <div className="flex items-center justify-between gap-3 mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gold-soft text-amber-600 flex items-center justify-center"><HandCoins size={18} /></div>
                    <div>
                      <div className="font-heading font-bold text-brand-ink">{formatRupiah(p.amount)}</div>
                      <div className="text-xs text-brand-muted">{p.tenor_months} bulan · {p.interest_rate}%/bln</div>
                    </div>
                  </div>
                  <span className={"inline-flex items-center rounded-full text-xs px-2.5 py-1 " + (p.status === "active" ? "bg-amber-100 text-amber-700" : p.status === "completed" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600")}>
                    {p.status}
                  </span>
                </div>
                <div className="grid grid-cols-3 gap-2 text-sm">
                  <Cell label="Terbayar" value={formatRupiah(p.paid_amount)} />
                  <Cell label="Sisa" value={formatRupiah(p.remaining_amount)} />
                  <Cell label="Diajukan" value={formatDate(p.applied_at)} />
                </div>
                {p.purpose && <div className="mt-3 text-sm text-brand-muted"><b className="text-brand-ink">Keperluan:</b> {p.purpose}</div>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </MemberLayout>
  );
}

function Cell({ label, value }) {
  return (
    <div className="rounded-xl bg-brand-soft/40 px-3 py-2">
      <div className="text-[10px] uppercase tracking-[0.18em] text-brand-muted">{label}</div>
      <div className="text-sm font-medium text-brand-ink truncate">{value}</div>
    </div>
  );
}
